import React, { Component } from "react";
import Menu from "./includes/Menu";
import { Grid } from "../../../node_modules/@material-ui/core";
import LocationIcon from "./../assets/images/location-icon.png";
import PhoneIcon from "./../assets/images/phone-icon.png";
import EmailIcon from "./../assets/images/email-icon.png";

import ImgMapEn from "./../assets/images/locationMapEn.png";
import ImgMapTc from "./../assets/images/locationMapTc.png";
import ImgMapSc from "./../assets/images/locationMapSc.png";

const lang = "";

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.lang = props.lang ? props.lang : "";
  }

  componentDidMount() {
    document.title = this.getLangText({
      tc: "聯絡我們",
      sc: "联络我们",
      en: "Contact Us"
    });
  }

  getLangText(langJson) {
    return this.lang ? langJson[this.lang] : langJson["tc"];
  }

  render() {
    return ContactUsJSX(this);
  }
}

const ContactUsJSX = ctx => (
  <div className={ctx.lang === "en" ? "en" : ""}>
    <Menu lang={ctx.lang} />

    <div
      className="main-content-container"
      style={{ minHeight: "100%", paddingBottom: "0" }}
    >
      <div className="main-content-inner-wrapper contactus">
        <Grid container spacing={0}>
          <Grid item id="page-title">
            <span>
              {ctx.getLangText({
                tc: "聯絡我們",
                sc: "联络我们",
                en: "Contact Us"
              })}
            </span>
          </Grid>
        </Grid>
      </div>
    </div>

    <div style={{ clear: "both" }} />

    <div className="contactus-grid-container-parent">
      <Grid container spacing={0} className="contactus-grid-container">
        <Grid item xs={12} sm={12} md={7} className="location-map">
          {ctx.lang==="sc"?(<img src={ImgMapSc} className="location-map-img" />)
          :ctx.lang==="en"?(<img src={ImgMapEn} className="location-map-img" />)
          :(<img src={ImgMapTc} className="location-map-img" />)
          }
        </Grid>

        <Grid item xs={12} sm={12} md={5} className="location-detail">
          <Grid item xs={12} className="detail-grid-name">
            {/* <h1 className="theme-color" style={{ fontSize: "24pt" }}>
              {ctx.getLangText({
                tc: "大中華區總部",
                sc: "大中华区总部",
                en: "Headquarters of Greater China"
              })}
            </h1> */}
          </Grid>
          <Grid item xs={12} className="detail-grid-addr">
            <Grid container spacing={0}>
              <Grid item>  
                <img src={LocationIcon} className="detail-img" />
              </Grid>
              <Grid item className="detail-desc">
                <span>
                  {ctx.getLangText({
                    tc: "香港九龍紅磡都會道10號都會大廈15樓1516室",
                    sc: "香港九龙红磡都会道10号都会大厦15楼1516室",
                    en:
                      "Room 1516, 15/F, Metropolis Tower, 10 Metropolis Drive, Hunghom, Kowloon, Hong Kong"
                  })}
                </span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className="detail-grid-phone">
            <Grid container spacing={0}>
              <Grid item>
                <img src={PhoneIcon} className="detail-img" />
              </Grid>
              <Grid item className="detail-desc" style={{ lineHeight: "30px" }}>
                <span>+852 3618 9535</span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className="detail-grid-email">
            <Grid container spacing={0}>
              <Grid item>
                <img src={EmailIcon} className="detail-img" />
              </Grid>
              <Grid
                item
                item
                className="detail-desc"
                style={{ lineHeight: "30px" }}
              >
                <a
                  className="default-text-color"
                  href="mailto:hongkong@fxhbgroup.com"
                  style={{ textDecoration: "none" }}
                >
                  <span>hongkong@fxhbgroup.com</span>
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  </div>
);

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/pages/ContactUs.js